<template>
  <div>
    <mh-image360-overlay
      :image-path="img360BasePath + currentVariation.item.id + '/Lv2/img01.jpg'"
      ref="image360Overlay"></mh-image360-overlay>
    <slot :getdatafield="getDataField"
          :getfiltereddatafield="getFilteredDataField">
      <div class="single container-max page-content">
        <div class="row position-relative">

          <div class="col-12 col-lg-6 pt-0 pt-lg-3 px-0 px-md-3">

            <mh-variation-tags :variation-properties="currentVariation.variationProperties"></mh-variation-tags>

            <mh-item-image-carousel :max-quantity="maxImageCount"
                                    image-url-accessor="url"></mh-item-image-carousel>

            <mh-image360-button :icon="modeherzPath + '/images/product/360.svg'"
                                :image-path="img360BasePath + currentVariation.item.id + '/Lv2/img01.jpg'"
                                @supported="set360Supported"

            ></mh-image360-button>
          </div>
          <div class="col-12 col-lg-6 px-0 px-lg-3">

            <div v-stick-in-parent>
              <!-- START SINGLEITEM_DETAILS -->

              <div class="d-flex justify-content-between px-3 px-lg-0 align-self-center flex-wrap flex-md-nowrap flex-lg-wrap flex-xl-nowrap mb-xl-3 pt-xl-5">
                <div class="mb-3 mt-3 mt-xl-0 mb-xl-0 px-3 px-lg-0 align-self-end order-2 order-md-1 order-lg-2 order-xl-1">
                  <mh-manufacturer-title :manufacturer="currentVariation.item.manufacturer"
                                         :category-id-name-map="mainCategoryIdNameMap"
                                         :lang="lang"
                  ></mh-manufacturer-title>
                  <h1 class="h2 title font-weight-normal">
                    <template v-if="productType">
                      <span class="product-type-title">{{ productType ? productType : ''}}</span>
                      <br>
                    </template>
                    {{ itemName1 }}
                  </h1>
                </div>
                <div class="manufacturer-logo align-self-end order-1 order-md-2 order-lg-1 order-xl-2 mb-2 mb-md-4 mb-lg-2 mb-xl-2 ml-3">
                  <mh-manufacturer-image :manufacturer="currentVariation.item.manufacturer"
                                         :category-id-name-map="mainCategoryIdNameMap"
                                         :lang="lang"
                  ></mh-manufacturer-image>
                </div>

              </div>

              <slot name="item-usps"></slot>

              <div class="bg-custom single-rightside p-4">

                <mh-variation-selection
                  :variation-id="currentVariation.variation.id"
                  :variation-properties="currentVariation.variationProperties"
                  :preload-image-limit="variationPreviewCount"
                ></mh-variation-selection>

                <div>
                  <slot name="tag-list"></slot>

                  <slot name="before-price"></slot>

                  <mh-variation-price :variation="currentVariation"
                                      :minimum-absolute-value="crossPriceMinimumAbsoluteValue"
                                      :minimum-percentage-value="crossPriceMinimumPercentage"
                                      :has-free-shipping="isFreeShipping"
                  ></mh-variation-price>

                  <slot name="after-price"></slot>

                  <div class="w-100">
                    <slot name="before-add-to-basket"></slot>
                  </div>

                  <div class="row my-3">

                    <div v-if="currentVariation.item.itemType === 'set'"
                         class="alert alert-info w-100">
                      {{ $translate("Ceres::Template.singleItemSetInfo") }}
                    </div>

                    <div v-else
                         class="col-12 col-md-7 col-xl-6">
                      <add-to-basket
                        :variation-id="currentVariation.variation.id"
                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                        :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                        :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                        :use-large-scale="false"
                        :show-quantity="true"
                        :item-url="currentVariation | itemURL"
                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                        :has-price="currentVariation | hasItemDefaultPrice"
                        :forbidden-country-codes="forbiddenCountryCodes"
                      >
                      </add-to-basket>
                    </div>

                    <div class="d-md-none col-6 col-md-4 col-xl-6 mt-3 mt-md-0 pl-md-0 single-wishlist"
                         v-if="isWishListEnabled">
                      <mh-single-share-button
                        :variation="currentVariation"></mh-single-share-button>
                    </div>
                    <div class="col-6 col-md-5 col-xl-6 mt-3 mt-md-0 pl-md-0 single-wishlist"
                         v-if="isWishListEnabled">
                      <mh-add-to-wish-list
                        :item-id="currentVariation.item.id"
                        :variation-id="currentVariation.variation.id"
                        @item-added="onItemAddToWishList"
                      ></mh-add-to-wish-list>
                    </div>
                  </div>

                  <slot name="additional-content-after-vat"></slot>

                  <hr class="d-md-none">

                  <div class="d-flex justify-content-around usps mt-4 mb-0 mb-md-4 flex-wrap flex-xl-nowrap">
                    <div class="flex-wrap justify-content-around">
                      <div class="single_availability d-flex align-items-center mt-3 mr-4">
                        <i class="fa far fa-clock mr-3 mr-lg-2"
                           aria-hidden="true">&nbsp;</i>
                        <span :class="'availability d-inline-block availability_' + currentVariation.variation.availability.id">
										    			<span>
										    				<b class="d-block">{{ $translate("modeherz::SingleItemPageClient.itemPageAvailability" + currentVariation.variation.availability.id + "Title") }}</b>
										    				<span class="d-inline-block">{{ $translate("modeherz::SingleItemPageClient.itemPageAvailability" + currentVariation.variation.availability.id + "Description") }}</span><sup
                                class="d-inline-block">7</sup>
										    			</span>
										    		</span>
                      </div>
                      <div class="single_delivery d-flex align-items-center mt-3 mr-4">
                        <i class="fa far fa-shipping-fast mr-2"
                           aria-hidden="true">&nbsp;</i>

                        <span v-if="!isFreeShipping"
                              class="d-inline-block ml-2">
										    			<b>{{ $translate("modeherz::SingleItemPageClient.itemPageFastDelivery") }}</b>
										    			<span>{{ $translate("modeherz::SingleItemPageClient.itemPagePremiumShipping") }}</span>
										    		</span>
                        <span v-else
                              class="d-inline-block ml-2">
										    			<b>{{ $translate("modeherz::SingleItemPageClient.itemPageFreeShipping") }}</b>
										    			<span>{{ $translate("modeherz::SingleItemPageClient.itemPageFreeShippingNote") }}</span>
										    		</span>
                      </div>

                      <div class="single_return_policy d-flex align-items-center mt-3">
                        <i class="fa far fa-undo-alt"
                           aria-hidden="true">&nbsp;</i>
                        <span class="d-inline-block ml-3 ml-lg-2">
                                                    <b>{{ $translate("modeherz::SingleItemPageClient.itemPageRightOfReturn") }}</b>
                                                    <template v-if="isGermanShippingCountry">
										    			<span>{{ $translate("modeherz::SingleItemPageClient.itemPageRightOfReturnDetailDe") }}</span>
                                                    </template>
                                                       <template v-else-if="isAustriaShippingCountry">
										    			<span>{{ $translate("modeherz::SingleItemPageClient.itemPageRightOfReturnDetailAt") }}</span>
                                                    </template>
                                                       <template v-else>
										    			<span>{{ $translate("modeherz::SingleItemPageClient.itemPageRightOfReturnDetailOther") }}</span>
                                                    </template>
										    	</span>
                      </div>
                    </div>
                  </div>

                  <div class="w-100 mt-3 after-add-to-basket">
                    <!-- order now -->
                    <client-only>
                      <slot name="after-add-to-basket"></slot>
                    </client-only>
                    <mh-order-now v-if="!!currentVariation.filter && currentVariation.filter.isSalable"
                                  :lang="lang"></mh-order-now>
                  </div>

                  <div class="d-flex align-items-end flex-wrap share-info mt-0">
                    <mh-share-buttons :variation="currentVariation"></mh-share-buttons>
                    <div class="mb-3 mb-md-0 mt-2 mt-md-0 text-center text-md-right variation-number order-1 order-md-2">
												<span class="small">
													<span>modeherz ID: {{ currentVariation.variation.id }}</span>&nbsp;|&nbsp;<span>{{ $translate("modeherz::SingleItemPageClient.itemPageVariationNo") }}:
														{{ currentVariation.variation.number }}</span>
												</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ./ITEM DETAIL -->
              <mh-product-safety-link></mh-product-safety-link>
              <mh-top-merchant-badge
                :variation-properties="currentVariation.variationProperties"></mh-top-merchant-badge>
              <div class="d-flex justify-content-center">
                <div data-authorizedby-badge="content"></div>
              </div>
              <slot name="additional-content-after-add-to-basket"></slot>

              <!-- END SINGLEITEM_DETAILS -->
            </div>
          </div>

          <div class="col-12 col-md-7 col-lg-6 px-4 single-description">
            <!-- ITEM DESCRIPTION -->
            <div class="my-5">
              <div class="tab-content overflow-hidden">
                <div class="tab-pane active overflow-auto"
                     :id="'details-' + currentVariation.variation.id"
                     role="tabpanel"
                     v-if="isDescriptionTabActive">
                  <div class="my-4"
                       v-html="currentVariation.texts.description"></div>
                </div>
                <slot name="add-detail-tabs-content"></slot>
              </div>
            </div>
            <!-- ./ITEM DESCRIPTION -->
          </div>

          <div class="col-12 col-md-5 col-lg-6 description-image">
            <div class="my-5">
              <mh-item-image
                v-if="currentVariation.images.all[1]"
                :img-url="currentVariation.images.all[1].url"
                :alt="currentVariation.texts.name1"
                :title="currentVariation.texts.name1"
                lazy
                img-class="img-fluid" />
              <mh-item-image
                v-else-if="currentVariation.images.all[0]"
                :img-url="currentVariation.images.all[0].url"
                :alt="currentVariation.texts.name1"
                :title="currentVariation.texts.name1"
                lazy
                img-class="img-fluid" />
            </div>
          </div>

          <product-safety-modal :variation-id="currentVariation.variation.id"></product-safety-modal>

        </div>
        <lazy-hydrate :when-visible="{ rootMargin: '300px' }">
          <div class="item-list-wrapper">
            <slot name="item-list-container"></slot>
          </div>
        </lazy-hydrate>
        <slot name="feedback-container"></slot>
      </div>
    </slot>
  </div>
</template>

<script>
  import { get } from "../../helper/get";
  import { isNullOrUndefined } from "../../helper/utils";
  import productTitleMixin from "../../../modeherz/mixins/propertyValue";
  import ProductSafetyModal from "../../../modeherz/components/item/ProductSafetyModal.vue";

  export default {

    name: "single-item",
    components: { ProductSafetyModal },
    mixins: [productTitleMixin],
    props: {
      pleaseSelectOptionVariationId: {
        type: Number,
        default: 0
      },
      initPleaseSelectOption: {
        type: Boolean,
        default: false
      },
      showNetPrices: {
        type: Boolean,
        default: false
      },
      isWishListEnabled: {
        type: Boolean,
        default: false
      },
      itemId: {
        type: Number,
        required: true
      },
      forbiddenCountryCodes: {
        type: Array,
        default: () => []
      },
      afterKey: Object
    },

    jsonDataFields: [
      "itemData",
      "attributesData",
      "variations"
    ],

    provide() {
      return {
        itemId: this.$props.itemId
      };
    },

    data() {
      return {
        crossPriceMinimumAbsoluteValue: App.modeherzPluginConfig.prices.crossPrice.minimumAbsoluteValue,
        crossPriceMinimumPercentage: App.modeherzPluginConfig.prices.crossPrice.minimumPercentage,
        variationPreviewCount: App.modeherzPluginConfig.item.image.variationPreviewCount,
        lang: App.language,
        modeherzPath: App.modeherzPluginConfig.publicPath,
        ceresPath: App.publicPath,
        img360BasePath: App.modeherzPluginConfig.item.image.img360BasePath,
        maxImageCount: App.modeherzPluginConfig.item.image.maxCount
      };
    },

    computed:
      {
        itemConfig() {
          return App.config.item.itemData;
        },

        isDescriptionTabActive() {
          return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
            && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive() {
          return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive() {
          return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId() {
          return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive() {
          return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
            && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties() {
          return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties() {
          return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
          return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
          return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
          return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
          return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
          return this.$store.state.items.isItemSet;
        },

        isFreeShipping() {
          return this.$store.state.localization.shippingCountryId == 1 && this.currentVariation.prices.default.price.value >= App.modeherzPluginConfig.prices.freeShippingCostLimit;
        },

        isGermanShippingCountry() {
          return this.$store.state.localization.shippingCountryId == 1;
        },

        isAustriaShippingCountry() {
          return this.$store.state.localization.shippingCountryId == 2;
        },

        mainCategoryIdNameMap() {
          return {
            [App.modeherzPluginConfig.navigation.main["1"]]: this.$translate("modeherz::Brands.brandsWomenCategoryPath"),
            [App.modeherzPluginConfig.navigation.main["2"]]: this.$translate("modeherz::Brands.brandsMenCategoryPath"),
            [App.modeherzPluginConfig.navigation.main["3"]]: this.$translate("modeherz::Brands.brandsChildrenCategoryPath")
          };
        },
        itemName1() {
          if (!this.currentVariation.texts.name1) {
            if (typeof window !== "undefined")
              console.error(new Error("no text name1", { props: this.currentVariation }));
          }
          const defaultValue = this.currentVariation.texts.name1?.replace(this.currentVariation.item.manufacturer.externalName, "");
          // const productTitle = this.getProductTitle(this.currentVariation.variationProperties,81, defaultValue)
          return defaultValue;
        },
        productType() {
          const productType = this.getPropertyValue(this.currentVariation.variationProperties, 11, null);
          return productType;
        }
      },

    created() {
      this.$store.dispatch("initVariation", this.itemData);
      this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted() {
      this.$nextTick(() => {
        this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
          itemId: this.itemId,
          attributes: this.attributesData,
          variations: this.variations,
          initialVariationId: this.currentVariation.variation.id,
          isPleaseSelectOption: this.initPleaseSelectOption,
          afterKey: this.afterKey
        });

        if (this.isItemSet) {
          this.$store.dispatch("initSetComponents", this.itemData);
        }
      });

      // listen for variation change to hydrate all children lazy-hydrate components
      document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },

    methods:
      {
        getDataField(field) {
          return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter) {
          if (!isNullOrUndefined(this.$options.filters[filter])) {
            return this.$options.filters[filter](this.getDataField(field));
          }

          return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes) {
          nodes.forEach(component => {
            if (component.$options.name === "lazy-hydrate") {
              component.hydrate();
            } else if (component.$children.length) {
              this.hydrateChildren(component.$children);
            }
          });
        },
        set360Supported() {
          this.$nextTick(() => this.$refs.image360Overlay?.setSupported());
        },
        onItemAddToWishList() {
          document.dispatchEvent(new CustomEvent("onItemAddToWishList", {
            detail: {
              id: this.currentVariation.variation.id,
              number: this.currentVariation.variation.number,
              name: this.currentVariation.texts.name1,
              price: this.currentVariation.prices.default.data.price.toFixed(2),
              priceNet: this.currentVariation.prices.default.data.priceNet.toFixed(2),
              amount: this.currentVariation.prices.default.data.price.toFixed(2),
              amountNet: this.currentVariation.prices.default.data.priceNet.toFixed(2),
              rrp: this.currentVariation.prices.rrp.data.priceNet.toFixed(2),
              rrpNet: this.currentVariation.prices.rrp.data.priceNet.toFixed(2),
              brand: this.currentVariation.item.manufacturer.externalName,
              quantity: 1
            }
          }));
        }
      }
  };
</script>
